import { render, staticRenderFns } from "./OTPStep.vue?vue&type=template&id=dd0059e6&scoped=true&"
import script from "./OTPStep.vue?vue&type=script&lang=js&"
export * from "./OTPStep.vue?vue&type=script&lang=js&"
import style0 from "./OTPStep.vue?vue&type=style&index=0&id=dd0059e6&prod&scoped=true&lang=css&"
import style1 from "./OTPStep.vue?vue&type=style&index=1&id=dd0059e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0059e6",
  null
  
)

export default component.exports